import React from "react";
import { DataBrokerageServiceQuestions } from "../components/FAQs/Data";
import Questions from "../components/FAQs/Questions";
import Join from "../components/Join/Join";
import TopBar from "../components/TopBar";
import { DataBrokerageServiceWelcomeBanner } from "../components/WelcomeBanner/Data";
import WelcomeBanner1 from "../components/WelcomeBanner/WelcomeBanner1";
import Footerr from "../components/Footerr/Footerr";
import ProgressBar from "../components/ProgressBar";

function BrokerageService() {
  return (
    <div>
      <ProgressBar />
      <TopBar />
      <WelcomeBanner1 data={DataBrokerageServiceWelcomeBanner} />
      <Join />
      <Questions data={DataBrokerageServiceQuestions} />
      <Footerr />
    </div>
  );
}

export default BrokerageService;
